import { Injectable } from '@angular/core';
import { AvailableFields } from '../interface';
import { FieldType } from '@vendasta/forms_microservice';
import { TranslateService } from '@ngx-translate/core';

const ELEMENT_FIELDS: AvailableFields = {
  labelKey: 'CUSTOM_FORMS.LIST_OF_FIELDS.ELEMENT',
  fields: [
    {
      fieldName: 'CUSTOM_FORMS.LIST_OF_FIELDS.FIELD_TYPES.RICH_TEXT_ELEMENT',
      formField: {
        id: 'element-rich-text',
        type: FieldType.FIELD_TYPE_RICH_TEXT_ELEMENT,
      },
    },
  ],
};

const GENERIC_FIELDS: AvailableFields = {
  labelKey: 'CUSTOM_FORMS.LIST_OF_FIELDS.GENERIC',
  fields: [
    {
      fieldName: 'CUSTOM_FORMS.LIST_OF_FIELDS.FIELD_TYPES.TEXT',
      formField: {
        id: 'generic-text',
        type: FieldType.FIELD_TYPE_STRING,
      },
    },
    {
      fieldName: 'CUSTOM_FORMS.LIST_OF_FIELDS.FIELD_TYPES.NUMBER',
      formField: {
        id: 'generic-integer',
        type: FieldType.FIELD_TYPE_INTEGER,
      },
    },
    {
      fieldName: 'CUSTOM_FORMS.LIST_OF_FIELDS.FIELD_TYPES.DROPDOWN',
      formField: {
        id: 'generic-dropdown',
        type: FieldType.FIELD_TYPE_DROPDOWN,
      },
    },
    {
      fieldName: 'CUSTOM_FORMS.LIST_OF_FIELDS.FIELD_TYPES.RADIO_BUTTON',
      formField: {
        id: 'generic-radio',
        type: FieldType.FIELD_TYPE_RADIO,
      },
    },
    {
      fieldName: 'CUSTOM_FORMS.LIST_OF_FIELDS.FIELD_TYPES.CHECKBOX',
      formField: {
        id: 'generic-boolean',
        type: FieldType.FIELD_TYPE_BOOLEAN,
      },
    },
    {
      fieldName: 'CUSTOM_FORMS.LIST_OF_FIELDS.FIELD_TYPES.DATE',
      formField: {
        id: 'generic-date',
        type: FieldType.FIELD_TYPE_DATE,
      },
    },
    {
      fieldName: 'CUSTOM_FORMS.LIST_OF_FIELDS.FIELD_TYPES.FILE',
      formField: {
        id: 'generic-file',
        type: FieldType.FIELD_TYPE_FILE,
      },
    },
  ],
};

@Injectable({ providedIn: 'root' })
export class UnmappedFieldService {
  constructor(private readonly translateService: TranslateService) {}

  getUnmappedFields(search: string): AvailableFields[] {
    const fields = [ELEMENT_FIELDS, GENERIC_FIELDS];

    return fields.map(
      (group) =>
        ({
          labelKey: group.labelKey,
          fields: group.fields
            .filter((field) => field.fieldName?.toLowerCase().includes(search.toLowerCase()))
            .map((field) => {
              field.fieldName = this.translateService.instant(field.fieldName ? field.fieldName : '');
              return field;
            }),
        }) as AvailableFields,
    );
  }
}
